import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src", "width", "height", "frameborder", "scrolling", "allowfullscreen"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.loaded && _ctx.getPropertyBooleanValue(_ctx.IframeTypeConst.VISIBLE))
    ? (_openBlock(), _createElementBlock("iframe", {
        key: 0,
        src: _ctx.getPropertyValue(_ctx.IframeTypeConst.SRC),
        width: _ctx.getPropertyNumberValue(_ctx.IframeTypeConst.WIDTH),
        height: _ctx.getPropertyNumberValue(_ctx.IframeTypeConst.HEIGHT),
        frameborder: _ctx.getPropertyNumberValue(_ctx.IframeTypeConst.FRAMEBORDER),
        scrolling: _ctx.getPropertyValue(_ctx.IframeTypeConst.SCROLLING),
        allowfullscreen: _ctx.getPropertyBooleanValue(_ctx.IframeTypeConst.ALLOWFULLSCREEN)
      }, "\r\n    ", 8 /* PROPS */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}